var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.impr.ibmStepCd !== "IS00000001" &&
                _vm.impr.suppleCheckFlag !== "Y",
              expression:
                "impr.ibmStepCd !== 'IS00000001' && impr.suppleCheckFlag !== 'Y'",
            },
          ],
          staticClass: "col-12",
        },
        [
          _c("c-step", {
            attrs: {
              stepperGrpCd: "IBM_STEP_CD",
              currentStepCd: _vm.impr.ibmStepCd,
              disabled: true,
            },
            model: {
              value: _vm.impr.ibmStepCd,
              callback: function ($$v) {
                _vm.$set(_vm.impr, "ibmStepCd", $$v)
              },
              expression: "impr.ibmStepCd",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.suppleFlag,
              expression: "suppleFlag",
            },
          ],
          staticClass: "col-12",
        },
        [
          _c("c-step", {
            attrs: {
              stepperGrpCd: "IBM_SUPPLE_STEP_CD",
              currentStepCd: _vm.impr.ibmSuppleStepCd,
              disabled: true,
            },
            model: {
              value: _vm.impr.ibmSuppleStepCd,
              callback: function ($$v) {
                _vm.$set(_vm.impr, "ibmSuppleStepCd", $$v)
              },
              expression: "impr.ibmSuppleStepCd",
            },
          }),
        ],
        1
      ),
      _vm.overFlag && this.impr.approvalStatusCd !== "ASC9999999"
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-banner",
                {
                  staticClass: "text-white bg-red",
                  attrs: { dense: "", "inline-actions": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "avatar",
                        fn: function () {
                          return [
                            _c("q-icon", {
                              attrs: {
                                name: "report_problem",
                                color: "grey-3",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    407695491
                  ),
                },
                [
                  _c("b", { staticClass: "text-h5" }, [
                    _vm._v(_vm._s(_vm.setLabel("LBL0001414"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.impr.suppleCheckFlag === "Y",
              expression: "impr.suppleCheckFlag === 'Y'",
            },
          ],
          class:
            _vm.impr.saveSuppleFlag === "Y"
              ? "col-xs-12 col-sm-12 col-md-12 col-lg-6"
              : "col-12",
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-form",
                  { ref: "editSuppleForm" },
                  [
                    _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "LBL0001427" },
                      },
                      [
                        _c(
                          "template",
                          { slot: "card-button" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleRequestEditable,
                                      expression: "suppleRequestEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isSaveSuppleRequest,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBL0001428",
                                    icon: "send",
                                  },
                                  on: {
                                    beforeAction: _vm.saveSuppleRequest,
                                    btnCallback: _vm.saveSuppleRequestCallback,
                                  },
                                }),
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleRequestEditable,
                                      expression: "suppleRequestEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isSaveSupple,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveSupple,
                                    btnCallback: _vm.saveSuppleCallback,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "template",
                          { slot: "card-description" },
                          [
                            !_vm.impr.saveSuppleFlag
                              ? _c(
                                  "font",
                                  {
                                    staticClass: "text-negative",
                                    staticStyle: {
                                      "font-size": "0.8em",
                                      "font-weight": "300",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.setLabel("LBL0001429")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 col-md-6 col-lg-4",
                            },
                            [
                              _c("c-select", {
                                attrs: {
                                  editable: _vm.suppleEditable,
                                  comboItems: _vm.suppleFlagItems,
                                  itemText: "codeName",
                                  itemValue: "code",
                                  label: "LBL0001430",
                                  name: "suppleFlag",
                                },
                                on: { datachange: _vm.supplechange },
                                model: {
                                  value: _vm.impr.suppleFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.impr, "suppleFlag", $$v)
                                  },
                                  expression: "impr.suppleFlag",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.impr.saveSuppleFlag === "Y"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-12 col-sm-6 col-md-6 col-lg-4",
                                },
                                [
                                  _c("c-datepicker", {
                                    attrs: {
                                      editable: _vm.suppleRequestEditable,
                                      required: true,
                                      label: "LBL0001431",
                                      name: "suppleScheduleDate",
                                    },
                                    model: {
                                      value: _vm.impr.suppleScheduleDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.impr,
                                          "suppleScheduleDate",
                                          $$v
                                        )
                                      },
                                      expression: "impr.suppleScheduleDate",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.impr.saveSuppleFlag === "Y"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                                },
                                [
                                  _c("c-textarea", {
                                    attrs: {
                                      editable: _vm.suppleRequestEditable,
                                      required: true,
                                      label: "LBL0001432",
                                      name: "suppleRequest",
                                    },
                                    model: {
                                      value: _vm.impr.suppleRequest,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.impr, "suppleRequest", $$v)
                                      },
                                      expression: "impr.suppleRequest",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.impr.saveSuppleFlag === "Y",
                                  expression: "impr.saveSuppleFlag === 'Y'",
                                },
                              ],
                              staticClass: "col-12",
                            },
                            [
                              _c("c-upload", {
                                ref: "suppleAttach",
                                attrs: {
                                  attachInfo: _vm.attachSupple,
                                  editable: _vm.suppleAttachEditable,
                                  label: "LBL0001433",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.impr.suppleCheckFlag === "Y" &&
                _vm.impr.saveSuppleFlag === "Y",
              expression:
                "impr.suppleCheckFlag === 'Y' && impr.saveSuppleFlag === 'Y'",
            },
          ],
          staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6",
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-form",
                  { ref: "editSuppleActionReviewForm" },
                  [
                    _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "LBL0001434" },
                      },
                      [
                        _c(
                          "template",
                          { slot: "card-button" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleReviewEditable,
                                      expression: "suppleReviewEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isSaveSuppleComplete,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBL0001435",
                                    icon: "directions_run",
                                  },
                                  on: {
                                    beforeAction: _vm.saveSuppleComplete,
                                    btnCallback: _vm.saveSuppleCompleteCallback,
                                  },
                                }),
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleActionEditable,
                                      expression: "suppleActionEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isSaveSuppleReview,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBL0001436",
                                    icon: "send",
                                  },
                                  on: {
                                    beforeAction: _vm.saveSuppleReview,
                                    btnCallback: _vm.saveSuppleReviewCallback,
                                  },
                                }),
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleActionReviewBtnEditable,
                                      expression:
                                        "suppleActionReviewBtnEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isSaveSuppleActionReview,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveSuppleActionReview,
                                    btnCallback:
                                      _vm.saveSuppleActionReviewCallback,
                                  },
                                }),
                                _c("c-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.suppleReviewEditable,
                                      expression: "suppleReviewEditable",
                                    },
                                  ],
                                  attrs: {
                                    isSubmit: _vm.isReturnSupple,
                                    url: _vm.saveUrl,
                                    param: _vm.impr,
                                    mappingType: "PUT",
                                    label: "LBL0001437",
                                    icon: "front_hand",
                                  },
                                  on: {
                                    beforeAction: _vm.returnSupple,
                                    btnCallback: _vm.returnSuppleCallback,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 col-md-6 col-lg-4",
                            },
                            [
                              _c("c-datepicker", {
                                attrs: {
                                  editable: _vm.suppleActionEditable,
                                  required: true,
                                  label: "LBL0001438",
                                  name: "suppleCompleteDate",
                                },
                                model: {
                                  value: _vm.impr.suppleCompleteDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.impr,
                                      "suppleCompleteDate",
                                      $$v
                                    )
                                  },
                                  expression: "impr.suppleCompleteDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                            },
                            [
                              _c("c-textarea", {
                                attrs: {
                                  editable: _vm.suppleActionEditable,
                                  required: true,
                                  rows: 4,
                                  label: "LBL0001439",
                                  name: "suppleActionContents",
                                },
                                model: {
                                  value: _vm.impr.suppleActionContents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.impr,
                                      "suppleActionContents",
                                      $$v
                                    )
                                  },
                                  expression: "impr.suppleActionContents",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                            },
                            [
                              _c("c-textarea", {
                                attrs: {
                                  editable: _vm.suppleReviewEditable,
                                  rows: 4,
                                  label: "LBL0001440",
                                  name: "suppleReviewContents",
                                },
                                model: {
                                  value: _vm.impr.suppleReviewContents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.impr,
                                      "suppleReviewContents",
                                      $$v
                                    )
                                  },
                                  expression: "impr.suppleReviewContents",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-form",
                { ref: "editForm1" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "LBL0001441" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c(_vm.relationTableInfo.component, {
                                key: _vm.relationTableInfo.key,
                                tag: "component",
                                attrs: {
                                  taskParam: _vm.relationTableInfo.taskParam,
                                  disabled: !Boolean(
                                    _vm.popupParam.sopImprovementId
                                  ),
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.requestAreaEditable &&
                                      _vm.popupParam.sopImprovementId,
                                    expression:
                                      "requestAreaEditable && popupParam.sopImprovementId",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isDelete,
                                  url: _vm.deleteUrl,
                                  param: _vm.impr,
                                  mappingType: "DELETE",
                                  label: "LBLREMOVE",
                                  icon: "remove",
                                },
                                on: {
                                  beforeAction: _vm.removeImpr,
                                  btnCallback: _vm.removeCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.requestBtnEditable,
                                    expression: "requestBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isRequest,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001442",
                                  icon: "send",
                                },
                                on: {
                                  beforeAction: _vm.requestImpr,
                                  btnCallback: _vm.requestCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.requestCancelBtnEditable,
                                    expression: "requestCancelBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isReject,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001443",
                                  icon: "delete_forever",
                                },
                                on: {
                                  beforeAction: _vm.rejectImpr,
                                  btnCallback: _vm.rejectCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.receiptBtnEditable,
                                    expression: "receiptBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isReceipt,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001444",
                                  icon: "directions_run",
                                },
                                on: {
                                  beforeAction: _vm.receiptImpr,
                                  btnCallback: _vm.receiptCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.saveBtnEditable1,
                                    expression: "saveBtnEditable1",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isSaveRequestReceipt,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: _vm.mappingType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveRequestReceiptImpr,
                                  btnCallback: _vm.saveRequestReceiptCallback,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3",
                          },
                          [
                            _c("c-select", {
                              attrs: {
                                disabled: true,
                                editable: _vm.editable,
                                codeGroupCd: "IBM_TASK_TYPE_CD",
                                type: "edit",
                                itemText: "codeName",
                                itemValue: "code",
                                name: "ibmTaskTypeCd",
                                label: "LBLWORK",
                              },
                              model: {
                                value: _vm.impr.ibmTaskTypeCd,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "ibmTaskTypeCd", $$v)
                                },
                                expression: "impr.ibmTaskTypeCd",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3",
                          },
                          [
                            _c("c-text", {
                              attrs: {
                                disabled: true,
                                editable: _vm.editable,
                                name: "sopImprovementId",
                                label: "LBL0001445",
                              },
                              model: {
                                value: _vm.impr.sopImprovementId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "sopImprovementId", $$v)
                                },
                                expression: "impr.sopImprovementId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: true,
                                label: "LBL0001446",
                                name: "request",
                                value: _vm.request,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.requestAreaEditable,
                                required: true,
                                label: "LBLTITLE",
                                name: "ibmTitle",
                              },
                              model: {
                                value: _vm.impr.ibmTitle,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "ibmTitle", $$v)
                                },
                                expression: "impr.ibmTitle",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.requestAreaEditable,
                                required: true,
                                label: "LBL0001447",
                                name: "improveRequestContents",
                              },
                              model: {
                                value: _vm.impr.improveRequestContents,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.impr,
                                    "improveRequestContents",
                                    $$v
                                  )
                                },
                                expression: "impr.improveRequestContents",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("c-plant", {
                                    attrs: {
                                      editable: _vm.requestAreaEditable,
                                      required: true,
                                      type: "edit",
                                      name: "plantCd",
                                    },
                                    model: {
                                      value: _vm.impr.plantCd,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.impr, "plantCd", $$v)
                                      },
                                      expression: "impr.plantCd",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c(
                              "c-dept",
                              {
                                attrs: {
                                  editable:
                                    _vm.requestAreaEditable ||
                                    _vm.actionReceiptAreaEditable,
                                  required: true,
                                  searchFlag: _vm.actionReceiptAreaEditable
                                    ? false
                                    : true,
                                  closeFlag: _vm.actionReceiptAreaEditable
                                    ? false
                                    : true,
                                  type: "edit",
                                  label: "LBL0001417",
                                  name: "actionDeptCd",
                                },
                                model: {
                                  value: _vm.impr.actionDeptCd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.impr, "actionDeptCd", $$v)
                                  },
                                  expression: "impr.actionDeptCd",
                                },
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "custom-btn-icon" },
                                  [
                                    _vm.actionReceiptAreaEditable
                                      ? _c(
                                          "q-icon",
                                          {
                                            staticClass: "cursor-pointer",
                                            attrs: { name: "autorenew" },
                                            on: {
                                              click: _vm.changeActionDeptImpr,
                                            },
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                attrs: {
                                                  anchor: "top middle",
                                                  self: "bottom middle",
                                                  offset: [10, 10],
                                                },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.setLabel("LBL0001449")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-multi-field", {
                              attrs: {
                                editable: _vm.actionReceiptAreaEditable,
                                required: true,
                                userInfo: _vm.userInfo,
                                isArray: "",
                                type: "dept_user",
                                label: "LBL0001416",
                                name: "actionUserIds",
                              },
                              on: {
                                "update:userInfo": function ($event) {
                                  _vm.userInfo = $event
                                },
                                "update:user-info": function ($event) {
                                  _vm.userInfo = $event
                                },
                              },
                              model: {
                                value: _vm.impr.actionUserIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "actionUserIds", $$v)
                                },
                                expression: "impr.actionUserIds",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-datepicker", {
                              attrs: {
                                editable: _vm.requestAreaEditable,
                                required: true,
                                label: "LBL0001419",
                                name: "actionCompleteRequestDate",
                              },
                              model: {
                                value: _vm.impr.actionCompleteRequestDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.impr,
                                    "actionCompleteRequestDate",
                                    $$v
                                  )
                                },
                                expression: "impr.actionCompleteRequestDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-field", {
                              attrs: {
                                editable:
                                  _vm.requestAreaEditable ||
                                  _vm.actionReceiptAreaEditable,
                                type: "dept_user",
                                data: _vm.impr,
                                deptValue: "actionCompleteCheckDeptCd",
                                label: "LBL0001451",
                                name: "actionCompleteCheckUserId",
                              },
                              model: {
                                value: _vm.impr.actionCompleteCheckUserId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.impr,
                                    "actionCompleteCheckUserId",
                                    $$v
                                  )
                                },
                                expression: "impr.actionCompleteCheckUserId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.actionReceiptAreaEditable,
                                label: "LBL0001452",
                                name: "requestRejectReason",
                              },
                              model: {
                                value: _vm.impr.requestRejectReason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "requestRejectReason", $$v)
                                },
                                expression: "impr.requestRejectReason",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-upload", {
                              attrs: {
                                isPhoto: true,
                                attachInfo: _vm.attachBeforeInfo,
                                editable:
                                  _vm.requestAreaEditable ||
                                  _vm.actionReceiptAreaEditable ||
                                  _vm.actionAreaEditable,
                                label: "LBL0001403",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.overFlag,
                  expression: "overFlag",
                },
              ],
              staticClass: "col-12",
            },
            [
              _c(
                "q-form",
                { ref: "overForm" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "LBL0001453" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-appr-btn", {
                                ref: "appr-btn",
                                attrs: {
                                  name: "work-permit-appr-btn",
                                  editable: _vm.overApprEditable,
                                  approvalInfo: _vm.approvalInfo,
                                },
                                on: {
                                  beforeApprAction: _vm.approvalOverImpr,
                                  callbackApprAction:
                                    _vm.approvalOverImrpCallback,
                                  requestAfterAction: _vm.getDetail,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.overEditable,
                                    expression: "overEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isOver,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveOverImpr,
                                  btnCallback: _vm.saveOverCallback,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-datepicker", {
                              attrs: {
                                editable: _vm.overEditable,
                                required: true,
                                start: _vm.$comm.getToday(),
                                label: "LBL0001454",
                                name: "targetDate",
                              },
                              model: {
                                value: _vm.impr.targetDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "targetDate", $$v)
                                },
                                expression: "impr.targetDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.overEditable,
                                required: true,
                                label: "LBL0001455",
                                name: "delayReason",
                              },
                              model: {
                                value: _vm.impr.delayReason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "delayReason", $$v)
                                },
                                expression: "impr.delayReason",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-form",
                { ref: "editForm2" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "LBL0001456" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.actionCompleteBtnEditable,
                                    expression: "actionCompleteBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isActionComplete,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001457",
                                  icon: "directions_run",
                                },
                                on: {
                                  beforeAction: _vm.actionCompleteImpr,
                                  btnCallback: _vm.actionCompleteCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.saveBtnEditable2,
                                    expression: "saveBtnEditable2",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isSaveAction,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveActionImpr,
                                  btnCallback: _vm.saveActionCallback,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-datepicker", {
                              attrs: {
                                editable: _vm.actionAreaEditable,
                                required: true,
                                label: "LBL0001405",
                                name: "actionCompleteDate",
                              },
                              model: {
                                value: _vm.impr.actionCompleteDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "actionCompleteDate", $$v)
                                },
                                expression: "impr.actionCompleteDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-datepicker", {
                              attrs: {
                                editable: _vm.actionAreaEditable,
                                required: true,
                                label: "LBL0001458",
                                name: "reviewCompleteRequestDate",
                              },
                              model: {
                                value: _vm.impr.reviewCompleteRequestDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.impr,
                                    "reviewCompleteRequestDate",
                                    $$v
                                  )
                                },
                                expression: "impr.reviewCompleteRequestDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                          },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.actionAreaEditable,
                                required: true,
                                label: "LBL0001404",
                                name: "actionContents",
                              },
                              model: {
                                value: _vm.impr.actionContents,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "actionContents", $$v)
                                },
                                expression: "impr.actionContents",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-upload", {
                              attrs: {
                                isPhoto: true,
                                attachInfo: _vm.attachAfterInfo,
                                editable: _vm.actionAreaEditable,
                                label: "LBL0001402",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-form",
                { ref: "editForm3" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "LBL0001459" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.completeBtnEditable,
                                    expression: "completeBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isComplete,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001460",
                                  icon: "check_circle_outline",
                                },
                                on: {
                                  beforeAction: _vm.completeImpr,
                                  btnCallback: _vm.completeCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.saveBtnEditable3,
                                    expression: "saveBtnEditable3",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isSaveCheck,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveCheckImpr,
                                  btnCallback: _vm.saveCheckCallback,
                                },
                              }),
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.rejectBtnEditable,
                                    expression: "rejectBtnEditable",
                                  },
                                ],
                                attrs: {
                                  isSubmit: _vm.isReturn,
                                  url: _vm.saveUrl,
                                  param: _vm.impr,
                                  mappingType: "PUT",
                                  label: "LBL0001437",
                                  icon: "front_hand",
                                },
                                on: {
                                  beforeAction: _vm.returnImpr,
                                  btnCallback: _vm.returnCallback,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-textarea", {
                              attrs: {
                                editable: _vm.requestCheckAreaEditable,
                                required: true,
                                label: "LBL0001461",
                                name: "reviewContents",
                              },
                              model: {
                                value: _vm.impr.reviewContents,
                                callback: function ($$v) {
                                  _vm.$set(_vm.impr, "reviewContents", $$v)
                                },
                                expression: "impr.reviewContents",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "q-dialog",
        {
          ref: "deptDialog",
          attrs: { persistent: "" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            "q-card",
            { staticClass: "dept-card" },
            [
              _c(
                "q-card-section",
                {
                  staticClass:
                    "row items-center q-pb-none px-2 py-1 bg-orange-custom text-white",
                },
                [
                  _c("div", { staticClass: "text-h6" }, [
                    _vm._v(_vm._s(_vm.setLabel("LBL0001462"))),
                  ]),
                  _c("q-space"),
                  _c("q-btn", {
                    attrs: { icon: "done", flat: "", round: "", dense: "" },
                    on: { click: _vm.selectDept },
                  }),
                  _c("q-btn", {
                    directives: [
                      { name: "close-popup", rawName: "v-close-popup" },
                    ],
                    attrs: { icon: "close", flat: "", round: "", dense: "" },
                  }),
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-section",
                    [
                      _c(
                        "q-item-label",
                        { attrs: { caption: "" } },
                        [
                          _c(
                            "q-chip",
                            {
                              attrs: {
                                outline: "",
                                color: "primary",
                                "text-color": "white",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.deptName) + " ")]
                          ),
                          _c("q-input", {
                            ref: "filter",
                            attrs: { dense: "", label: "Filter" },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _vm.filter !== ""
                                      ? _c("q-icon", {
                                          staticClass: "cursor-pointer",
                                          attrs: { name: "clear" },
                                          on: { click: _vm.resetFilter },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.filter,
                              callback: function ($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("q-separator"),
              _c(
                "q-card-section",
                { staticClass: "dept-content p-2" },
                [
                  _c("q-tree", {
                    ref: "imprActionDept",
                    attrs: {
                      nodes: _vm.deptTree,
                      "node-key": "deptCd",
                      "label-key": "deptName",
                      "children-key": "children",
                      "no-nodes-label": "setMessage('MSGNOFILTERING')",
                      "no-results-label": _vm.setMessage("MSGNOFILTERING"),
                      filter: _vm.filter,
                      "default-expand-all": true,
                      "selected-color": "primary",
                      selected: _vm.selected,
                    },
                    on: {
                      "update:selected": function ($event) {
                        _vm.selected = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }